import { Directive, ElementRef, OnDestroy, AfterViewInit } from '@angular/core';

@Directive({ selector: '[fixed-table-header]' })
export class FixedTableHeaderDirective implements AfterViewInit {
  el: any;
  target: any;
  tbody: any;
  lastTranslateValue: number = 0;

  constructor(el: ElementRef) {
    this.el = el.nativeElement;

    this._onScroll = this._onScroll.bind(this);
  }

  ngAfterViewInit() {
    let elSelector = this.el.getAttribute('fixed-table-header');

    if (!elSelector) {
      this.target = this.el.querySelector('thead');
      this.tbody = this.el.querySelector('tbody');
    } else {
      this.target = document.querySelector(elSelector);

      if (!this.target) {
        console.warn('fixed-table-header:', 'invalid target query', elSelector);
        return;
      }
    }

    window.addEventListener('scroll', this._onScroll);

    this.updateScroll();
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this._onScroll);
  }

  updateScroll() {
    let scrollAmount = window.pageYOffset || document.documentElement.scrollTop;
    let marginTop = this.target.clientHeight;
    this.target.style.transform = '';

    let bounds = this.target.getBoundingClientRect();

    let offset = -bounds.top;

    if (offset < 0) offset = 0;

    this.target.style.transform = `translate(0,${offset}px)`;
    if (this.tbody && this.tbody.querySelector('.rankings-hide-scores')) {
      this.tbody.querySelector('.rankings-hide-scores').style.marginTop =
        offset + marginTop + 'px';
    }
  }

  _onScroll(evt) {
    this.updateScroll();
  }
}
